import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Form } from "antd";
import TextArea from "antd/es/input/TextArea";

export default function Cancel() {
  const navigate = useNavigate();
  const params = useParams();
  const [form] = Form.useForm();

  function onBack() {
    navigate(-1);
  }

  function onSubmit() {
    // TODO: wire cancel API
  }

  function onReschedule() {
    if (params.id) navigate(`/appointments/reschedule/${params.id}`);
  }

  return (
    <div className="min-h-full bg-medpharma-mist/40">
      <div className="mx-auto max-w-lg">
        <div className="mb-6">
          <Button
            type="text"
            onClick={onBack}
            className="flex items-center gap-2 text-primary-blue hover:!text-primary-blue/80 -ml-2"
            aria-label="Go back"
          >
            Back
          </Button>
        </div>

        <div className="rounded-2xl border border-slate-200/80 bg-white shadow-card overflow-hidden">
          <div className="border-b border-slate-200/80 bg-slate-50/50 px-6 py-4">
            <h1 className="text-lg font-semibold text-slate-800 tracking-tight">
              Cancel appointment
            </h1>
            <p className="mt-1 text-sm text-slate-500">
              Optionally tell us why you’re canceling
            </p>
          </div>

          <Form
            form={form}
            name="cancel"
            layout="vertical"
            autoComplete="off"
            className="p-6"
          >
            <Form.Item
              name="cancelReason"
              label="Reason for canceling (optional)"
            >
              <TextArea
                rows={4}
                placeholder="e.g. Schedule conflict, patient no-show…"
                className="rounded-xl"
              />
            </Form.Item>

            <Form.Item className="mb-3">
              <Button
                type="primary"
                size="large"
                onClick={onReschedule}
                className="w-full !bg-primary-blue hover:!bg-primary-blue/90 font-semibold"
              >
                Reschedule instead
              </Button>
            </Form.Item>

            <Form.Item className="mb-3">
              <Button
                danger
                size="large"
                onClick={onSubmit}
                htmlType="submit"
                className="w-full"
              >
                Cancel appointment
              </Button>
            </Form.Item>

            <Button size="large" onClick={onBack} className="w-full">
              Back
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
}
